import { InputLabel } from "@material-ui/core";
import { createStyles, makeStyles } from "@material-ui/styles";
import * as React from "react";

import { Location } from "../../domain";
import { LocationSearchModeEnum, LocationSearchScopeEnum } from "../../modules";
import { Chip } from "../chips/chip";
import { mergeClasses } from "../styles/mergeClasses";
import { RelodeTheme } from "../styles/relodeTheme";
import { LocationSearch } from "./locationSearch";

const useStyles = makeStyles(
    (theme: RelodeTheme) =>
        createStyles({
            root: {},
            extraLabel: {},
            select: {
                marginBottom: theme.spacing(1),
            },
        }),
    { name: "LocationCollection" }
);

interface Props {
    classes?: Partial<ReturnType<typeof useStyles>>;
    locations?: Location[];
    label?: string;
    fieldLabel: string;
    onChange: (locations: Location[]) => void;
    scope: LocationSearchScopeEnum;
    mode: LocationSearchModeEnum;
    error?: boolean;
    helperText?: string;
}

export interface LocationCollectionProps extends Props {}

export const LocationCollection = (props: Props) => {
    const classes = mergeClasses(useStyles({}), props.classes);

    const handleAdd = (item: never, location: Location) => {
        if (!location) return;

        const { locations: _locations } = props;
        let secondaryLocations: Location[] = [];
        if (_locations) {
            secondaryLocations = [..._locations];
        }
        if (
            secondaryLocations.findIndex(
                loc => loc.locationId === location.locationId
            ) < 0
        ) {
            secondaryLocations.push(location);
        }
        props.onChange(secondaryLocations);
    };

    const handleRemove = (id: number, deletedLocation: Location) => {
        if (!deletedLocation) return;

        const { locations: _locations } = props;
        let secondaryLocations: Location[] = [];
        if (_locations) {
            secondaryLocations = [..._locations];
            const locationIndex = secondaryLocations.findIndex(
                location => location.locationId === deletedLocation.locationId
            );
            secondaryLocations.splice(locationIndex, 1);
            props.onChange(secondaryLocations);
        }
    };

    return (
        <div className={classes.root}>
            {props.label && (
                <InputLabel className={classes.extraLabel}>
                    {props.label}
                </InputLabel>
            )}
            <LocationSearch
                id="locationCollection"
                clearInputOnAdd
                classes={{
                    root: classes.select,
                }}
                label={props.fieldLabel}
                error={props.error}
                helperText={props.helperText}
                scope={props.scope}
                mode={props.mode}
                onSelect={handleAdd}
                disableClearable
            />
            {!!props.locations &&
                props.locations.map((location: Location, i: number) => (
                    <Chip
                        key={`${location.locationId}-${location.locationName}`}
                        value={location}
                        label={location.locationName}
                        id={location.locationId}
                        onChipDelete={handleRemove}
                    />
                ))}
        </div>
    );
};
